import React from "react";
import NavOnlyLogo from "../Componets/layout/Navbar/NavOnlyLogo";
import Logincom from "../Componets/Login/Logincom";

function login() {
  return (
    <>
      <NavOnlyLogo />
      <Logincom />
    </>
  );
}

export default login;
